<template>
    <div class="fill-height bg_auth" style="width: 100%">
        <v-layout wrap class="login">
            <center :class="!$vuetify.display.mobile ? 'login_card' : 'login_card_mobile'">
                <v-flex xs12 class="text-center">
                    <v-img
                        src="/img/bobbee_logo_3.png"
                        :height="!$vuetify.display.mobile ? '15vh' : ''"
                        :width="!$vuetify.display.mobile ? '' : '25vw'"
                    />
                </v-flex>
                <v-flex xs12 class="align-center">
                    <h2>Besoin d'un nouveau mot de passe ?</h2>
                    <p>
                        Entrez l'adresse email de votre compte bobbee.<br />
                        Un email vous sera envoyé avec un lien de réinitialisation de votre mot de
                        passe
                    </p>
                    <v-form ref="form" v-model="valid" @submit.prevent="sendRecoveryLink">
                        <v-text-field
                            mt-4
                            class="mt-4"
                            xs4
                            v-model="email"
                            placeholder="Email"
                            :rules="[() => pattern.test(email) || 'Email invalide']"
                            required
                        />
                        <v-row>
                            <v-col xs12 class="text-center mt-4">
                                <v-btn @click="sendRecoveryLink" block>Envoyer</v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col xs12 class="text-center">
                                <router-link :to="'/login'" style="cursor: pointer; color: black"
                                    >Retour pour vous connecter</router-link
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-flex>

                <v-flex xs12 mt-5 pt-5 class="align-center">
                    <v-alert rounded type="primary" variant="outlined" :model-value="isMailSent"
                        >Un mail a été envoyé a l'adresse email indiquée.<br />
                        Vous y trouverez les instructions pour modifier votre mot de passe.
                    </v-alert>
                </v-flex>
            </center>
        </v-layout>
    </div>
</template>
<script lang="ts">
import SEND_RECOVER_PASSORD_LINK from "../../graphql/SendRecoverPasswordLink.gql";

import { emailPattern } from "../../services/emailServices";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class PasswordRecovery extends Vue {
    email: string = "";

    valid = false;
    isMailSent = false;

    get pattern() {
        return emailPattern;
    }

    sendRecoveryLink() {
        // @ts-ignore
        if (!this.$refs.form.validate()) return;
        this.$apollo.mutate({
            mutation: SEND_RECOVER_PASSORD_LINK,
            variables: {
                email: this.email,
            },
            update: () => {
                this.isMailSent = true;
            },
        });
    }
}

export default toNative(PasswordRecovery);
</script>
<style scoped>
.background_image {
    background-color: #f9b12a !important;
}
.bg_auth {
    height: "100%";
    display: flex;
    flex-direction: column;
    justify-content: right;
    background-image: url("../../assets/img/bg_auth.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: center;
}
</style>
